const Swiper = require('swiper').default;
const Navigation = require('swiper').Navigation;
const Scrollbar = require('swiper').Scrollbar;

Swiper.use([Navigation, Scrollbar]);

function pdpSwiper() {
    const pdpSwiper = new Swiper('.js-pdp-slider', {
        loop: false,
        centerInsufficientSlides: true,
        grabCursor: true,
        slidesPerView: 1,
        observeParents: true,
        observer: true,
        scrollbar: {
            el: '.js-pdp-slider .swiper-scrollbar-container > .swiper-scrollbar',
            draggable: true,
            hide: false,
        },
    });

    const thumbnails = document.querySelectorAll('.js-product-images-thumbs .js-product-images-item');

    thumbnails.forEach((thumb) => {
        thumb.addEventListener('click', () => {
          const slideIndex = thumb.getAttribute('data-slide');
          pdpSwiper.slideTo(parseInt(slideIndex));
        });
    });

    pdpSwiper.on('slideChange', () => {
        thumbnails.forEach(thumb => thumb.classList.remove('active'));
        const activeThumb = thumbnails[pdpSwiper.realIndex];
        activeThumb.classList.add('active');
    });
}

/**
* Initializes the file
*/
function init() {
    $(document).ready(() => {
        pdpSwiper();
    });
}

module.exports = {
    init: init
};
